import { useState, useEffect } from 'react';

export const useThemeMode = () => {
    const [mode, setMode] = useState<'light' | 'dark'>(
        window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light',
    );

    useEffect(() => {
        function handleModeChange(event: MediaQueryListEvent) {
            setMode(event.matches ? 'dark' : 'light');
        }
        window.matchMedia('(prefers-color-scheme: dark)').addListener(handleModeChange);

        return () => {
            window.matchMedia('(prefers-color-scheme: dark)').removeListener(handleModeChange);
        };
    }, []);

    return mode;
};
